export default __webpack_public_path__ + "static/media/GC Login 1.372e522c.jpg";